/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import {
  VehicleDeactivationConfirmationComponent
} from '@vehicles/vehicle-deactivation-confirmation/vehicle-deactivation-confirmation.component';
import { VehicleDetailComponent } from '@vehicles/vehicle-detail/vehicle-detail.component';
import { VehiclesComponent } from '@vehicles/vehicles/vehicles.component';

@NgModule({
    declarations: [
        VehiclesComponent,
        VehicleDetailComponent,
        VehicleDeactivationConfirmationComponent,
    ],
    imports: [
        SharedModule
    ],
    exports: [
        VehiclesComponent
    ]
})
export class VehiclesModule { }
